// extracted by mini-css-extract-plugin
export default {"dashmain":"DashboardOut_dashmain__DwLEj","sider":"DashboardOut_sider__HIUIf","linkscon":"DashboardOut_linkscon__+ih9M"};